import { render } from "./ExpansionCard.vue?vue&type=template&id=0416d2e5&scoped=true"
import script from "./ExpansionCard.vue?vue&type=script&lang=ts"
export * from "./ExpansionCard.vue?vue&type=script&lang=ts"

import "./ExpansionCard.vue?vue&type=style&index=0&id=0416d2e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0416d2e5"

export default script